export default {
    name: 'MetadataTab',
    props: {
        recallData: {
            type: Object,
            default: null
        },
        isLoading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        tokenPercentage() {
            if (!this.recallData?.metadata?.llm) {
                return { input: 0, output: 0 }
            }
            const total = this.recallData.metadata.llm.total_tokens
            const input = this.recallData.metadata.llm.input_tokens
            const output = this.recallData.metadata.llm.output_tokens

            return {
                input: (input / total) * 100,
                output: (output / total) * 100
            }
        }
    },
    methods: {
        formatDateTime(date) {
            if (!date) return '-'
            try {
                const d = new Date(date)
                if (isNaN(d.getTime())) return '-'
                return d.toLocaleString('en-US', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: true
                })
            } catch (error) {
                return '-'
            }
        },

        formatNumber(num) {
            if (num === null || num === undefined) return '-'
            return num.toLocaleString('en-US')
        },

        getStatusClass(status) {
            const statusMap = {
                'COMPLETED': 'badge-success',
                'PENDING': 'badge-warning',
                'IN_PROGRESS': 'badge-info',
                'FAILED': 'badge-danger'
            }
            return statusMap[status] || 'badge-secondary'
        }
    }
}
